export const KEY_CODE_MAP = {
  TAB: 9,
  ESCAPE: 27,
  ARROW_RIGHT: 39,
  ARROW_UP: 38,
  ARROW_LEFT: 37,
  ARROW_DOWN: 40,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  HOME: 36,
  END: 35,
  ALT: 18,
}

export const KEY_STRING_MAP = {
  TAB: 'Tab',
  ESCAPE: 'Escape',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_DOWN: 'ArrowDown',
  PAGE_DOWN: 'PageDown',
  PAGE_UP: 'PageUp',
  HOME: 'Home',
  END: 'End',
  ALT: 'Alt',
  ALT_LEFT: 'AltLeft',
  ALT_RIGHT: 'AltRight',
}

export const FOCUSABLE_ELEMENT_SELECTORS = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled],[tabindex="-1"]), iframe, object, [tabindex="0"], [contenteditable]'
